export function blockEnterBehavior(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    event.stopPropagation();
  }
}
